import { AbstractService } from "./abstract.service";
import axios from "axios";

export class LinkMposServices extends AbstractService {

  static get URL_GATEWAY() {
    return process.env.VUE_APP_URL_GATEWAY_MPOS_CORE;
  }
  static get entity() {
    return "migrate"
  }

  static get URL_GATEWAY_URL() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }
  static get entityApiUrl() {
    return "n360/mcmnt"
  }

  static async getLinkToAccount(params) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/mng-inte-app/link-app`, params);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  static async removeLinkToAccount(params) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/mng-inte-app/link-app`, params);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  static async getDataCore(params) {
    try {
      const response = await axios.get(`${this.URL_GATEWAY}/${this.entity}/${params.merchantId}/provider/${params.providerCode}`,
        {
          headers: {
            Authorization: `Bearer ${params.tokenHead}`
          }
        }
      );
      return response.data
    } catch (error) {
      console.log(error)
    }
  }
}
